export enum ProjectListType {
  MAIN = 'MAIN',
  ASSETS = 'ASSETS',
  CLAIMS = 'CLAIMS'
}
